export default {"src":"/_next/static/media/worldchain.62d1dfd2.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};